<script setup name="TvbHomeSmallBanner">
import request from '@/utils/request'
import { reactive, ref, inject } from 'vue'

import TvbHomeSmallBannerTemplateTwo from './components/TemplateTwo/index.vue'
import TvbHomeSmallBannerTemplateThree from './components/TemplateThree/index.vue'
const templateRef = ref()
const size = inject('size')
const props = defineProps({
  info: {
    type: Object,
    default: null
  }
})
const smallBanner = reactive({
  big: null,
  list: [],
  template: 0,
  moreUrl: ''
})

const smallBannerTemplates = {
  2: TvbHomeSmallBannerTemplateTwo,
  3: TvbHomeSmallBannerTemplateThree
}

if (props.info.api) {
  request({
    url: props.info.api,
    method: 'get'
  }).then(({ data }) => {
    let { list, template } = data
    if (6 < list.length && template === 2) {
      list = list.concat(list.slice(0, 6 - (list.length % 6)))
    } else if (template === 3) {
      smallBanner.big = list[0]
      list = list.slice(1)
      list = list.length > 4 ? list.concat(list.slice(0, 4 - (list.length % 4))) : list
    }
    smallBanner.template = template
    smallBanner.list = list
  })
}
</script>

<template>
  <section class="tvb-home-small-banner" v-if="smallBanner.list.length" :class="[size]">
    <header class="tvb-home-small-banner-header">
      <h2 class="tvb-home-small-banner-title">
        <component
          :is="smallBanner?.moreUrl ? 'tvb-router-link' : 'span'"
          :to="smallBanner?.moreUrl"
        >
          {{ info.title }}
        </component>
      </h2>
      <div
        class="tvb-home-small-banner-swiper-navigation"
        v-if="(smallBanner.template === 2 ? 6 : 5) < smallBanner.list.length"
      >
        <div class="tvb-home-small-banner-swiper-navigation-prev" @click="templateRef?.slidePrev()">
          <TvbSvgIcon class="arrow-icon" name="icon_list_arrow_grey_" />
          <TvbSvgIcon class="arrow-icon" name="icon_list_arrow_blue" />
        </div>
        <div class="tvb-home-small-banner-swiper-navigation-next" @click="templateRef?.slideNext()">
          <TvbSvgIcon class="arrow-icon" name="icon_list_arrow_grey_" />
          <TvbSvgIcon class="arrow-icon" name="icon_list_arrow_blue" />
        </div>
      </div>
    </header>
    <component
      :list="smallBanner.list"
      :is="smallBannerTemplates[smallBanner.template]"
      :big="smallBanner.big"
      :info="props.info"
      ref="templateRef"
    />
  </section>
</template>

<style lang="scss" scoped>
.tvb-home-small-banner {
  min-width: 320px;
  .tvb-home-small-banner-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tvb-home-small-banner-title {
      font-size: 24px;
      font-weight: 500;
      color: #1e1e1e;
      line-height: 36px;
      letter-spacing: 0.5px;
      > a {
        text-decoration: none;
        color: inherit;
        transition: color 0.15s linear;
        &:hover {
          color: rgba(0, 98, 163, 1);
        }
      }
    }

    .tvb-home-small-banner-swiper-navigation {
      display: flex;
      align-items: center;
      justify-content: center;

      .tvb-home-small-banner-swiper-navigation-prev {
        svg {
          transform: rotate(180deg);
          &:nth-child(2) {
            transform: rotate(0deg) !important;
          }
        }
      }

      .tvb-home-small-banner-swiper-navigation-prev,
      .tvb-home-small-banner-swiper-navigation-next {
        transition: all 0.15s linear;
        width: 36px;
        height: 36px;
        border-radius: 36px;
        background: #f8f9fa;
        border: 0.5px solid rgba(163, 178, 188, 0.35);
        margin-left: 24px;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        svg {
          width: 16px;
          height: 16px;
          &:nth-child(2) {
            display: none;
            transform: rotate(180deg);
          }
        }

        &:hover {
          background: #ffffff;
          svg {
            &:nth-child(1) {
              display: none;
            }
            &:nth-child(2) {
              display: block;
            }
          }
        }

        &:active {
          opacity: 0.75;
        }
      }

      .tvb-home-small-banner-swiper-navigation-next {
        margin-left: 12px;
      }
    }
  }
  &.s,
  &.xs {
    .tvb-home-small-banner-header {
      padding: 0 12px;
      align-items: center;
      .tvb-home-small-banner-title {
        font-size: 17px;
        font-weight: 500;
        color: #1e1e1e;
        line-height: 24px;
      }

      .tvb-home-small-banner-swiper-navigation {
        display: none;
      }
    }
  }

  &.s {
    .tvb-home-small-banner-header {
      padding: 0 16px;
    }
  }
}
</style>
